import Flag from 'LuxKit/Flag'
import type { ComponentProps } from 'react'
import { memo, useMemo } from 'react'
import { useIntl } from 'react-intl'
import type { PhonePrefixCountry } from './PhoneInput.types'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import styled from 'styled-components'
import { isolatePhoneNumber } from 'lib/format/formatPhoneNumber'

const HidableListItem = styled(ClickableListItem)`
  &[hidden] {
    display: none;
  }

`

interface Props extends Pick<ComponentProps<typeof ClickableListItem>, 'size'> {
  onSelect: (country: PhonePrefixCountry) => void
  selected?: boolean
  country: PhonePrefixCountry
  hidden?: boolean
}

function PhonePrefixItem(props: Props) {
  const { country, selected, onSelect, hidden, size = 'small' } = props
  const intl = useIntl()
  const countryCode = country.iso2.toUpperCase()

  const countryDisplayNames = useMemo(
    () => new Intl.DisplayNames(intl.locale, { type: 'region' }),
    [intl.locale],
  )
  const countryName = countryDisplayNames.of(countryCode) ?? country.name
  // Keep "+<code>" as an LTR island so RTL locales don't render "(1+)".
  const dialCode = isolatePhoneNumber(`+${country.dialCode}`)

  const onClick = () => {
    onSelect(country)
  }

  return <HidableListItem
    size={size}
    title={intl.formatMessage({
      id: 'TacfwiCvHSKONh3EpRjQ',
      defaultMessage: '{countryName} ({dialCode})',
    }, { countryName, dialCode })}
    startIcon={<Flag countryCode={countryCode} />}
    selected={selected}
    onClick={onClick}
    hidden={hidden}
  />
}

export default memo(PhonePrefixItem)
